import { useState } from "react";
import React, { useCallback, useEffect, useRef } from "react";

import {
  buildCompleteProtectionFinalAmountPayload,
  isUpgradeFromEnhancedMonitoring,
} from "../../helpers/generatePropertySecurityQuestions";

import { useDispatch, useSelector } from "react-redux";

import { Box, Button, Typography } from "@mui/material";

import CardPayment from "./CardPayment";
import { Loader } from "../../common/loader";
import CreditCardForm from "./CreditCardForm";
import { ROLES } from "../../helpers/constants";
import AlertDialog from "../../common/AlertDialog";
import SubscriptionPlans from "./SubscriptionPlans";
import PaidAtClosingConfirm from "./PaidAtClosingConfirm";
import OwnerVerification from "./OwnerVerification";
import SecurityInfoScreen from "./SecurityInfoScreen";
import CategoryWisePricing from "./CategoryWisePricing";
import SignatureScreen from "../../user-signup/signatureScreen";
import BeneficiaryForm from "../../user-signup/BeneficiaryForm";
import {
  decryptPayload,
  getObjLength,
  requiresSecurityPin,
} from "../../helpers/utils";
import { mapCreateUserApiUrl } from "../../for-service-provider/createUserApiPaths";
import { getSignupLastStep } from "../../for-service-provider/servicerOnboardingDisplay";
import SecurityPinGeneration from "../../common/SecurityPinGeneration";
import { postAPIPayload } from "../../../apis/postApi";
import { userSigupAction } from "../../../redux/slices/user/userSignUpSlice";
import { userProfileAction } from "../../../redux/slices/user/userProfileSlice";
import { propertyUsersAction } from "../../../redux/slices/admin/propertyUsers/propertyUsersSlice";
import { propertyRiskManagementAction } from "../../../redux/slices/admin/property-risk-management/propertyRiskManagementSlice";

const SecurityInfoAndCardPayment = ({
  onCloseModalHandler,
  screen,
  onChangeModalScreen,
  isByPassOptionAvailable,
  isAdminCreateUser = false,
  backToSearchProperty,
  selectedData,
  editProperty,
  addPromoCode = false,
  from = "",
  skipVerification = false,
  isShow = true,
  setSkipVerification,
  onSkipVerificationPopupChange,
  suppressGlobalLoader = false,
  isUserCreateProperty = false,
  // Owner Verification's Next sets fromPropertyList, but the CAR "Invite or
  // Purchase" screen replaces this component; the plans must still quote the
  // properties from that list when it comes back.
  startFromPropertyList = false,
  handleCloseAddPropertyModal = () => {},
  completedProcess = () => {},
  user_id = null,
  tabComponent = false,
  selectedRowData = {},
  isResumeSignup = false,
  promoCode = undefined,
  titleCompanyUser = {},
  setIsPropertyAdded = () => {},
  isAssistant = false,
  isServiceProvider = false,
  enablePaymentScreen = true,
  user_category = "complete_protection",
  isAdmin = false,
  isUpgradeCategory = false,
  userEmail = undefined,
  isTailwindComponent = false,
  disableBasicMonitoring = false,
  onGenerateSecurityQuestions = () => {},
  isEnhancedToCompleteProtection = false,
  ownershipVerifiedViaId = false,
  ownershipVerificationAlreadyComplete = false,
  continueUserId = null,
  epAwareSessionId = null,
  completeProtectionOnly = false,
  // C.A.R. (RE) agent: go past "Owner Verified" straight to the next step.
  skipOwnerVerifiedPage = false,
}) => {
  const dispatch = useDispatch();
  const [isBeneficiariesSkip, setIsBeneficiariesSkip] = useState(false);

  const { selectedUserID, selectedProperty, isQuestionByPass } = useSelector(
    (state) => state.properties,
  );
  const {
    mailingAddress,
    statesCodeList,
    subscriptionPlans,
    createAccResponse,
    investorsID,
    investorsAnnualPlanData,
    verifiedPropertiesList,
    propertyIds: stagedPropertyIds,
    sendMailLoader,
  } = useSelector((state) => state.signUpUser);
  const { propertyUsersLoader, securityPINResponse } = useSelector(
    (state) => state.propertyUsers,
  );
  const { subscribeFreeMonitoring, riskManagementLoader } = useSelector(
    (state) => state?.propertyRiskManagement,
  );

  const { userProfileDetails, cardDetails, cardLoader } = useSelector(
    (state) => state?.userProfile,
  );
  const isCustomer = userProfileDetails?.data?.role?.includes(ROLES?.customer);
  const admin_id = userProfileDetails?.data?.user_id;
  const category =
    decryptPayload(localStorage.getItem("category")) || user_category;
  // states
  const [answers, setAnswers] = useState({});
  const [planId, setPlanId] = useState("");
  const [yearlyPlan, setYearlyPlan] = useState();
  const [fromPropertyList, setFromPropertyList] = useState(startFromPropertyList);
  // The wizard can be on screen before a payment resume decides this.
  useEffect(() => {
    if (startFromPropertyList) {
      setFromPropertyList(true);
    }
  }, [startFromPropertyList]);
  const [planDetails, setPlanDetails] = useState(yearlyPlan);
  const [finalAmount, setFinalAmount] = useState(yearlyPlan);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [adminChangeCategory, setAdminChangeCategory] = useState(null);
  const upgradePaymentPrimedRef = useRef(false);
  const enhancedResumeWelcomeEmailSentRef = useRef(false);
  // True once this run sent send-welcome-email after the PIN. Resume Signup
  // that lands straight on Beneficiary never sets it, so that step still
  // sends the email itself.
  const [welcomeSentAfterPin, setWelcomeSentAfterPin] = useState(false);
  // Holds the PIN screen (with a loader) until send-welcome-email responds.
  const [awaitingWelcomeEmail, setAwaitingWelcomeEmail] = useState(false);

  useEffect(() => {
    if (!awaitingWelcomeEmail || sendMailLoader) {
      return;
    }
    // Success or failure: continue to Beneficiary. If it failed, that step
    // sends the welcome email itself at the end (welcomeEmailAfterPin gate).
    setAwaitingWelcomeEmail(false);
    onChangeModalScreen("beneficiaries");
    dispatch(propertyUsersAction.fetchSecurityPINData({}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [awaitingWelcomeEmail, sendMailLoader]);

  const resolvedCategory = adminChangeCategory || category;

  useEffect(() => {
    if (screen !== "welcome" || !isResumeSignup) {
      return;
    }

    if (resolvedCategory !== "enhanced_monitoring") {
      return;
    }

    if (enhancedResumeWelcomeEmailSentRef.current || !user_id) {
      return;
    }

    enhancedResumeWelcomeEmailSentRef.current = true;
    void postAPIPayload({
      url: "send-welcome-email",
      data: {
        user_id,
        step: 7,
        step_key: "SEND_WELCOME_EMAIL",
        silent: true,
      },
    }).catch(() => {});
  }, [isResumeSignup, resolvedCategory, screen, user_id]);

  useEffect(() => {
    // let data = {
    //   user_id: getObjLength(createAccResponse)
    //     ? createAccResponse.data?.user_id
    //     : userIdFromSession,
    //   step: 2,
    //   step_key: "GET_MAILING_ADDRESS",
    // };
    // dispatch(
    //   userSigupAction.getMailingAddress({
    //     url: "get-mailing-address",
    //     data: data,
    //   })
    // );
    // dispatch(
    //   userSigupAction.getStateCode({ url: "get-states-code", data: {} })
    // );
    let plan = subscriptionPlans?.data?.find((i) => i.name === "Yearly");
    setYearlyPlan(plan);
    if (isEnhancedToCompleteProtection) {
      setPlanId(plan?.plan_id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isUpgradeCategory) {
      return;
    }

    const targetCategory = adminChangeCategory || category;
    if (targetCategory !== "complete_protection") {
      return;
    }

    if (screen !== "cardsInfo" && screen !== "subscriptions") {
      return;
    }

    if (upgradePaymentPrimedRef.current) {
      return;
    }

    const plans = subscriptionPlans?.data;
    if (!Array.isArray(plans) || plans.length === 0) {
      return;
    }

    const resolvedUserId = selectedUserID || user_id;
    if (!resolvedUserId || !getObjLength(selectedProperty)) {
      return;
    }

    const payloadResult = buildCompleteProtectionFinalAmountPayload({
      subscriptionPlans,
      property: selectedProperty,
      userId: resolvedUserId,
      upgradeFromEnhanced:
        isEnhancedToCompleteProtection ||
        isUpgradeFromEnhancedMonitoring(selectedProperty),
    });

    if (!payloadResult) {
      return;
    }

    upgradePaymentPrimedRef.current = true;
    const { data, find_plan, url } = payloadResult;
    const isSpPaymentChoiceScreen =
      screen === "subscriptions" && isServiceProvider && isAdminCreateUser;

    setPlanId(String(find_plan.plan_id));
    localStorage.setItem(
      "planDetails",
      JSON.stringify({ plan_id: find_plan.plan_id, plan_Name: find_plan.name }),
    );
    localStorage.setItem(
      "Plan_Data",
      JSON.stringify({ ...data, state: selectedProperty?.state }),
    );
    localStorage.setItem("Plan_Name", JSON.stringify(find_plan.name));

    // SP payment-choice screen: skip get-final-amount priming so Order
    // Summary does not open on default load. Card path still quotes when
    // the user chooses Client pay now and activates a plan.
    if (!isSpPaymentChoiceScreen) {
      dispatch(
        userSigupAction.getTotalPaymentDetails({
          url: mapCreateUserApiUrl(url, isServiceProvider),
          data,
          ...(isServiceProvider ? { token: true } : {}),
        }),
      );
    }
    dispatch(
      userSigupAction.getMailingAddress({
        url: "get-mailing-address",
        data: {
          user_id: resolvedUserId,
          step: 2,
          step_key: "GET_MAILING_ADDRESS",
        },
      }),
    );
    if (!getObjLength(statesCodeList)) {
      dispatch(
        userSigupAction.getStateCode({ url: "get-states-code", data: {} }),
      );
    }

    // Admin CP upgrade skips plan choice and goes straight to cards.
    // SP /clients/{id} upgrade stays on subscriptions for Bill me at closing /
    // Client pay now after add-multiple succeeds.
    if (screen === "subscriptions" && !isSpPaymentChoiceScreen) {
      onChangeModalScreen("cardsInfo");
    }
  }, [
    adminChangeCategory,
    category,
    dispatch,
    isAdminCreateUser,
    isEnhancedToCompleteProtection,
    isServiceProvider,
    isUpgradeCategory,
    onChangeModalScreen,
    screen,
    selectedProperty,
    selectedUserID,
    statesCodeList,
    subscriptionPlans,
    user_id,
  ]);

  // Admin workspace Add Property + Paid Enhanced skips plans/Order Summary and
  // lands on card payment right after add-property-in-report. Load the
  // Enhanced plan and its final amount before the payment form renders so it
  // never reads a stale Plan_Data from a previous flow.
  const isAdminPaidEnhancedAddPropertyPayment =
    screen === "cardsInfo" &&
    from === "add-property" &&
    Boolean(isAdmin) &&
    !isServiceProvider &&
    !isAdminCreateUser &&
    !isResumeSignup &&
    !isUpgradeCategory &&
    !isUserCreateProperty &&
    resolvedCategory === "enhanced_monitoring";
  const awaitingAdminEnhancedPaymentPlan =
    isAdminPaidEnhancedAddPropertyPayment && !planId;
  const enhancedPlansRequestedRef = useRef(false);
  const [adminEnhancedPaymentError, setAdminEnhancedPaymentError] =
    useState("");

  useEffect(() => {
    if (!awaitingAdminEnhancedPaymentPlan) {
      return;
    }

    const plansLoaded = getObjLength(subscriptionPlans);
    const enhancedPlan = subscriptionPlans?.data?.find?.(
      (plan) => plan?.product_tier === "enhanced_monitoring",
    );
    if (!enhancedPlan) {
      if (!enhancedPlansRequestedRef.current) {
        enhancedPlansRequestedRef.current = true;
        dispatch(
          userSigupAction.getSubscriptionPlan({
            url: "get-plans",
            data: {},
            type: "post",
          }),
        );
      } else if (plansLoaded) {
        setAdminEnhancedPaymentError(
          "We couldn't load the Enhanced Monitoring plan. Close and try again.",
        );
      }
      return;
    }

    const resolvedUserId = user_id || selectedUserID;
    if (!resolvedUserId || !selectedProperty?.property_id) {
      setAdminEnhancedPaymentError(
        "We couldn't load property details for payment. Close and try again.",
      );
      return;
    }

    const data = {
      plan_id: parseInt(enhancedPlan.plan_id),
      user_id: resolvedUserId,
      property_id: [selectedProperty.property_id],
      property_ids: [
        {
          address: selectedProperty?.address,
          property_id: selectedProperty?.property_id,
          city: selectedProperty?.city,
          state: selectedProperty?.state,
          zip: selectedProperty?.zip,
        },
      ],
    };
    const storedPromoCode = localStorage.getItem("promoCode");
    if (storedPromoCode) {
      data.promo_code = storedPromoCode;
    }

    localStorage.setItem("add_subscription_category", "enhanced_monitoring");
    localStorage.setItem(
      "planDetails",
      JSON.stringify({
        plan_id: enhancedPlan.plan_id,
        plan_Name: enhancedPlan.name,
      }),
    );
    localStorage.setItem(
      "Plan_Data",
      JSON.stringify({ ...data, state: selectedProperty?.state }),
    );
    localStorage.setItem("Plan_Name", JSON.stringify(enhancedPlan.name));

    dispatch(
      userSigupAction.getTotalPaymentDetails({
        url: "get-final-amount-enhanced-monitoring",
        data,
      }),
    );
    dispatch(
      userSigupAction.getMailingAddress({
        url: "get-mailing-address",
        data: {
          user_id: resolvedUserId,
          step: 2,
          step_key: "GET_MAILING_ADDRESS",
        },
      }),
    );
    if (!getObjLength(statesCodeList)) {
      dispatch(
        userSigupAction.getStateCode({ url: "get-states-code", data: {} }),
      );
    }

    setAdminEnhancedPaymentError("");
    setPlanId(enhancedPlan.plan_id);
  }, [
    awaitingAdminEnhancedPaymentPlan,
    dispatch,
    selectedProperty,
    selectedUserID,
    statesCodeList,
    subscriptionPlans,
    user_id,
  ]);

  useEffect(() => {
    if (planId) {
      const subscriptions = investorsID
        ? investorsAnnualPlanData
        : subscriptionPlans;
      const planData = subscriptions?.data?.filter(
        (i) => i.plan_id === parseInt(planId),
      );
      console.log("e.target.value==>", planData?.[0]);
      setPlanDetails(planData?.[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [planId, investorsID]);

  const paymentUserId = user_id || selectedUserID;
  const isSpPersonalUse = isServiceProvider && !isAdminCreateUser;
  const isRealAdmin = Boolean(isAdmin) && !isServiceProvider;

  const cardListAPI = useCallback(() => {
    let cardUrl = "customer/card/list";

    if (isServiceProvider && isAdminCreateUser && paymentUserId) {
      // SP creating/paying for a client workspace user
      cardUrl = `service-provider/customer/users/${paymentUserId}/card`;
    } else if (isServiceProvider || isSpPersonalUse) {
      // SP personal (/servicer-properties) — never admin/users/.../card
      cardUrl = "service-provider/card/list";
    } else if (isRealAdmin && paymentUserId) {
      // Super admin / internal admin only
      cardUrl = `admin/users/${paymentUserId}/card`;
    }

    dispatch(
      userProfileAction.userCardDetails({
        url: cardUrl,
        data: {},
        token: !isAssistant || isServiceProvider,
        brokertoken: isAssistant && !isServiceProvider,
      }),
    );
  }, [
    dispatch,
    isAdminCreateUser,
    isAssistant,
    isRealAdmin,
    isServiceProvider,
    isSpPersonalUse,
    paymentUserId,
  ]);

  // SP/admin add-property for an existing client, or SP client enrollment /
  // Complete Payment: prefer saved-cards checkout when cards exist.
  // Incomplete signup (step < 4) with no cards uses the signup Payment details
  // form (CreditCardForm) instead of Payment Information (CardPayment).
  const isSpClientEnrollmentCheckout =
    isServiceProvider && isAdminCreateUser && Boolean(paymentUserId);
  const { step: clientSignupStep } = getSignupLastStep(selectedRowData);
  const cardsResponseReady =
    !cardLoader &&
    (cardDetails?.success === true ||
      cardDetails?.success === false ||
      Array.isArray(cardDetails?.data));
  const hasSavedCards =
    Array.isArray(cardDetails?.data) && cardDetails.data.length > 0;
  const isIncompleteSignupPayment =
    isSpClientEnrollmentCheckout &&
    (clientSignupStep == null || clientSignupStep < 4);
  const awaitingCardCheckoutDecision =
    isIncompleteSignupPayment && !cardsResponseReady;
  const preferSignupPaymentDetails =
    isIncompleteSignupPayment && cardsResponseReady && !hasSavedCards;

  const baseUseClientSavedCardsCheckout =
    !isAdminCreateUser ||
    (isServiceProvider && Boolean(paymentUserId)) ||
    (isServiceProvider && from === "add-property");

  const useClientSavedCardsCheckout =
    baseUseClientSavedCardsCheckout &&
    !preferSignupPaymentDetails &&
    !awaitingCardCheckoutDecision;

  useEffect(() => {
    if (from !== "add-property") return;
    if (!isAssistant || enablePaymentScreen) {
      cardListAPI();
    }
  }, [from, isAssistant, enablePaymentScreen, cardListAPI]);

  useEffect(() => {
    if (
      screen !== "cardsInfo" &&
      !(
        screen === "subscriptions" &&
        isServiceProvider &&
        isAdminCreateUser &&
        paymentUserId
      )
    ) {
      return;
    }
    if (!baseUseClientSavedCardsCheckout) {
      return;
    }
    cardListAPI();
  }, [
    screen,
    baseUseClientSavedCardsCheckout,
    cardListAPI,
    isServiceProvider,
    isAdminCreateUser,
    paymentUserId,
  ]);

  const onFinalPIN = (pin) => {
    const resolvedUserId =
      user_id ||
      selectedUserID ||
      (getObjLength(createAccResponse)
        ? createAccResponse.data?.user_id
        : JSON.parse(localStorage.getItem("user_Id") || "null"));

    const isCustomerSelfServicePin =
      isCustomer &&
      !isAdminCreateUser &&
      !isAssistant &&
      (isUpgradeCategory || isEnhancedToCompleteProtection);

    const basePayload = {
      security_pin: pin,
      user_id: resolvedUserId,
      step: 5,
      step_key: "SECURITY_PIN",
    };

    if (isCustomerSelfServicePin) {
      dispatch(
        propertyUsersAction.getSecurityPIN({
          url: "security-pin",
          data: basePayload,
          token: true,
        }),
      );
      return;
    }

    dispatch(
      propertyUsersAction.getSecurityPIN({
        url: "security-pin",
        data: {
          ...basePayload,
          from_admin: 1,
          admin_id: admin_id,
        },
        token: true,
      }),
    );
  };

  // Completes a basic/enhanced monitoring signup without a security PIN.
  // Mirrors the non-Complete-Protection branch of handleMonitoringLastStep so it
  // can be triggered directly when the PIN step is skipped for monitoring plans.
  const finishMonitoringSignup = useCallback(() => {
    const risk_report_ids = verifiedPropertiesList?.data?.map(
      (i) => !i?.not_added && i?.id,
    );
    dispatch(
      propertyRiskManagementAction.subscribeFreeMonitoring({
        url: `county-subscription/bulk`,
        data: {
          step: 7,
          step_key: "SEND_WELCOME_EMAIL",
          category: category,
          risk_report_ids: risk_report_ids,
          user_id:
            (getObjLength(createAccResponse)
              ? createAccResponse.data?.user_id
              : JSON.parse(localStorage.getItem("user_Id"))) || user_id,
          action: 1,
        },
      }),
    );
    dispatch(propertyUsersAction.fetchSecurityPINData({}));
  }, [category, createAccResponse, dispatch, user_id, verifiedPropertiesList]);

  const handleMonitoringLastStep = () => {
    if (isUpgradeCategory || isEnhancedToCompleteProtection) {
      dispatch(propertyUsersAction.fetchSecurityPINData({}));
      if (isCustomer) {
        dispatch(
          userProfileAction.userProfileData({
            url: "profile",
            data: {},
            token: true,
          }),
        );
      }
      onCloseModalHandler("pin-complete");
      return;
    }

    if (
      category === "complete_protection" ||
      adminChangeCategory === "complete_protection"
    ) {
      // Admin / SP / assistant create-user and Resume Signup: finalize the
      // signup (welcome email + SEND_WELCOME_EMAIL step) as soon as the PIN is
      // saved, same as /create-account, so a drop-off at Beneficiary no longer
      // leaves the account pending. Same payload the end-of-step call used
      // (from_admin keeps activation on the admin payment step). Beneficiary
      // step follows as before and skips its own welcome email when this
      // one succeeded.
      const welcomeUserId =
        user_id ||
        selectedUserID ||
        (getObjLength(createAccResponse)
          ? createAccResponse.data?.user_id
          : JSON.parse(localStorage.getItem("user_Id") || "null"));
      if (welcomeUserId) {
        // Not silent: stay on the PIN screen with a loader until the response
        // is back (see the awaitingWelcomeEmail effect), so the beneficiary
        // save can never race the welcome call.
        setWelcomeSentAfterPin(true);
        setAwaitingWelcomeEmail(true);
        dispatch(
          userSigupAction.sendSignUpMail({
            url: "send-welcome-email",
            data: {
              user_id: welcomeUserId,
              from_admin: 1,
              admin_id,
              step: 7,
              step_key: "SEND_WELCOME_EMAIL",
            },
          }),
        );
        return;
      }
      // onChangeModalScreen("bio-metric"); // to skip bio-metric & signature step
      onChangeModalScreen("beneficiaries");
      dispatch(propertyUsersAction.fetchSecurityPINData({}));
    } else {
      // Enhanced Monitoring (incl. Eldorado complimentary resume): welcome.
      finishMonitoringSignup();
    }
  };

  const goToSignatureStep = () => {
    dispatch(
      userSigupAction.skipRegisterFaceStep({
        url: "skip-face",
        data: {
          user_id:
            (getObjLength(createAccResponse)
              ? createAccResponse.data?.user_id
              : JSON.parse(localStorage.getItem("user_Id"))) || user_id,
          admin_id: admin_id,
          from_admin: 1,
        },
      }),
    );
    onChangeModalScreen("signature");
  };

  const skipBenificiary = () => {
    const resolvedUserId =
      (getObjLength(createAccResponse)
        ? createAccResponse.data?.user_id
        : JSON.parse(localStorage.getItem("user_Id") || "null")) || user_id;

    dispatch(
      userSigupAction.skipBeneficiaryStep({
        url: mapCreateUserApiUrl("skip-beneficiary", isServiceProvider),
        data: {
          user_id: resolvedUserId,
          admin_id: admin_id,
          from_admin: 1,
        },
        ...(isServiceProvider ? { token: true } : {}),
      }),
    );
    setIsBeneficiariesSkip(true);
  };

  const closeSubscribeModal = () => {
    dispatch(propertyRiskManagementAction.clearPropertyRiskManagementData({}));
    dispatch(propertyRiskManagementAction.fetchSubscribeFreeMonitoring({}));
  };

  useEffect(() => {
    if (
      getObjLength(subscribeFreeMonitoring) &&
      subscribeFreeMonitoring?.success
    ) {
      if (
        category !== "complete_protection" &&
        adminChangeCategory !== "complete_protection"
      ) {
        closeSubscribeModal();
        onChangeModalScreen("welcome");
        setIsBeneficiariesSkip(false);
      }
    }
  }, [subscribeFreeMonitoring]);

  return (
    <Box
    // className={`mb-5 profile-wrapper ${
    //   screen === "cardsInfo" ? "pb-0" : ""
    // } bg-white`}
    >
      {screen === "categoryWisePricing" && (
        <CategoryWisePricing
          setSelectedCategory={setSelectedCategory}
          selectedCategory={
            selectedCategory || adminChangeCategory || category
          }
          setPlanId={setPlanId}
          setFinalAmount={setFinalAmount}
          // values from props
          onChangeModalScreen={onChangeModalScreen}
          handleCloseAddPropertyModal={handleCloseAddPropertyModal}
          from={from}
          isUserCreateProperty={isUserCreateProperty}
          uid={user_id || continueUserId}
          selectedData={selectedRowData}
          isAdmin={isAdmin}
          isTailwindComponent={isTailwindComponent}
          disableBasicMonitoring={disableBasicMonitoring}
          isUpgradeCategory={isUpgradeCategory}
          onGenerateSecurityQuestions={onGenerateSecurityQuestions}
          isServiceProvider={isServiceProvider}
          isAdminCreateUser={isAdminCreateUser}
          subscriptionbyAdmin={
            isAdmin || (isServiceProvider && isAdminCreateUser)
          }
          workspaceUser={selectedRowData}
          showAllSubscriptionCategories={
            isAdmin || (isServiceProvider && isAdminCreateUser)
          }
          completeProtectionOnly={completeProtectionOnly}
        />
      )}
      {screen === "questions" && (
        <SecurityInfoScreen
          isShow={isShow}
          onChangeModalScreen={(scr) =>
            // isByPassOptionAvailable || isAdminCreateUser
            // editProperty
            //   ? onCloseModalHandler("success"):
            {
              if (isCustomer || isUserCreateProperty) {
                onChangeModalScreen("cardsInfo");
              } else {
                onChangeModalScreen(scr);
              }
            }
          }
          handleCloseAddPropertyModal={handleCloseAddPropertyModal}
          onCloseModalHandler={onCloseModalHandler}
          backToSearchProperty={backToSearchProperty}
          setAnswers={setAnswers}
          isByPassOptionAvailable={isByPassOptionAvailable}
          isAdminCreateUser={isAdminCreateUser}
          editProperty={editProperty}
          oldPropertyData={selectedData}
          setSkipVerification={setSkipVerification}
          onSkipVerificationPopupChange={onSkipVerificationPopupChange}
          user_id={user_id}
          selectedRowData={selectedRowData}
          promoCode={promoCode}
          isUpgradeCategory={isUpgradeCategory}
          userEmail={userEmail}
          isTailwindComponent={isTailwindComponent}
          isServiceProvider={isServiceProvider}
          ownershipVerifiedViaId={ownershipVerifiedViaId}
          ownershipVerificationAlreadyComplete={
            ownershipVerificationAlreadyComplete
          }
          continueUserId={continueUserId}
          epAwareSessionId={epAwareSessionId}
          category={adminChangeCategory ? adminChangeCategory : category}
          isQuestionByPass={isQuestionByPass}
          skipVerification={skipVerification}
        />
      )}

      {screen === "propertyList" && (
        <OwnerVerification
          // A CAR agent enrolls one property per client (portfolio row).
          hideAddAnotherProperty={completeProtectionOnly && isServiceProvider}
          autoContinue={skipOwnerVerifiedPage}
          onChangeModalScreen={onChangeModalScreen}
          setFromPropertyList={setFromPropertyList}
          user_id={user_id}
          isResumeSignup={isResumeSignup}
          isAdminCreateUser={isAdminCreateUser}
          setIsPropertyAdded={setIsPropertyAdded}
          titleCompanyUser={titleCompanyUser}
          isAssistant={isAssistant}
          isServiceProvider={isServiceProvider}
          category={category}
          isAdmin={isAdmin}
          setAdminChangeCategory={setAdminChangeCategory}
          selectedRowData={selectedRowData}
          isTailwindComponent={isTailwindComponent}
          skipVerification={skipVerification}
          setSkipVerification={setSkipVerification}
          finishMonitoringSignup={finishMonitoringSignup}
        />
      )}

      {screen === "subscriptions" && (
        <SubscriptionPlans
          isShow={isShow}
          handleCloseAddPropertyModal={handleCloseAddPropertyModal}
          from={from}
          planId={setPlanId}
          onChangeModalScreen={onChangeModalScreen}
          isByPassOptionAvailable={isByPassOptionAvailable}
          isAdminCreateUser={isAdminCreateUser}
          setFinalAmount={setFinalAmount}
          setSkipVerification={setSkipVerification}
          isUserCreateProperty={isUserCreateProperty}
          fromPropertyList={fromPropertyList}
          showSource={isResumeSignup}
          uid={user_id}
          selectedData={selectedRowData}
          promoCode={
            from === "add-property"
              ? promoCode
              : titleCompanyUser
                ? promoCode
                : selectedRowData?.userPromocode?.promocode_name
          }
          titleCompanyUser={titleCompanyUser}
          category={adminChangeCategory ? adminChangeCategory : category}
          isTailwindComponent={isTailwindComponent}
          isServiceProvider={isServiceProvider}
        />
      )}
      {screen === "paidAtClosing" &&
        isServiceProvider &&
        isAdminCreateUser &&
        resolvedCategory === "complete_protection" && (
          <PaidAtClosingConfirm
            onChangeModalScreen={onChangeModalScreen}
            onCloseModalHandler={onCloseModalHandler}
            completedProcess={completedProcess}
            finalAmount={finalAmount}
            planDetails={planDetails}
            user_id={user_id}
            selectedData={selectedRowData}
            isTailwindComponent={isTailwindComponent}
            isServiceProvider={isServiceProvider}
            backScreen="subscriptions"
          />
        )}
      {screen === "cardsInfo" &&
        (awaitingAdminEnhancedPaymentPlan && adminEnhancedPaymentError ? (
          <Box className="bg-white px-5 py-4 text-center">
            <Typography className="text-danger mb-3">
              {adminEnhancedPaymentError}
            </Typography>
            <Button
              variant="outlined"
              onClick={() => handleCloseAddPropertyModal()}
            >
              Close
            </Button>
          </Box>
        ) : awaitingCardCheckoutDecision ||
          awaitingAdminEnhancedPaymentPlan ? (
          <Loader open={true} />
        ) : useClientSavedCardsCheckout ? (
          <CardPayment
            isShow={isShow}
            handleCloseAddPropertyModal={handleCloseAddPropertyModal}
            planId={planId}
            answers={answers}
            onChangeModalScreen={(nextScreen) => {
              // Paid Enhanced skipped plans; Back returns to the category picker.
              if (
                isAdminPaidEnhancedAddPropertyPayment &&
                nextScreen === "subscriptions"
              ) {
                onChangeModalScreen("categoryWisePricingFromAdmin");
                return;
              }
              onChangeModalScreen(nextScreen);
            }}
            onCloseModalHandler={onCloseModalHandler}
            isByPassOptionAvailable={isByPassOptionAvailable}
            isAdminCreateUser={isAdminCreateUser}
            selectedData={
              from === "add-property" || isUserCreateProperty
                ? selectedProperty
                : selectedData
            }
            addPromoCode={addPromoCode}
            promoCode={promoCode}
            from={from}
            uid={paymentUserId}
            callListingAPI={cardListAPI}
            skipVerification={skipVerification}
            isUserCreateProperty={isUserCreateProperty}
            tabComponent={tabComponent}
            propertiesIds={
              Array.isArray(stagedPropertyIds) && stagedPropertyIds.length > 0
                ? stagedPropertyIds
                : undefined
            }
            isAssistant={isAssistant}
            isServiceProvider={isServiceProvider}
            selectedCategory={
              isAdmin || (isServiceProvider && isAdminCreateUser)
                ? category
                : selectedCategory || category
            }
            // Only true admin roles use admin card/payment paths.
            // SP client enrollment uses isAdminCreateUser + isServiceProvider instead.
            isAdmin={isAdmin && !isServiceProvider}
            isUpgradeCategory={isUpgradeCategory}
            finalAmount={finalAmount}
            onFinalAmountChange={setFinalAmount}
            userEmail={userEmail}
            isTailwindComponent={isTailwindComponent}
            isEnhancedToCompleteProtection={isEnhancedToCompleteProtection}
            ownershipVerificationAlreadyComplete={
              ownershipVerificationAlreadyComplete
            }
          />
        ) : (
          <Box className={`bg-white px-5 pt-2`}>
            <CreditCardForm
              isShow={isShow}
              mailingAddress={mailingAddress?.data?.address}
              mailingData={mailingAddress?.data}
              stateCodesData={statesCodeList}
              planDetails={planDetails}
              onChangeModalScreen={onChangeModalScreen}
              finalAmount={finalAmount}
              onFinalAmountChange={setFinalAmount}
              onCloseModalHandler={onCloseModalHandler}
              fromPropertyList={
                fromPropertyList || preferSignupPaymentDetails
              }
              setFromPropertyList={setFromPropertyList}
              user_id={user_id || paymentUserId}
              promoCode={promoCode}
              selectedData={selectedRowData}
              titleCompanyUser={titleCompanyUser}
              category={adminChangeCategory ? adminChangeCategory : category}
              isAdmin={isAdmin && !isServiceProvider}
              isUpgradeCategory={isUpgradeCategory}
              from={from}
              isEnhancedToCompleteProtection={isEnhancedToCompleteProtection}
              isUserCreateProperty={isUserCreateProperty}
              userEmail={userEmail}
              isTailwindComponent={isTailwindComponent}
              isServiceProvider={isServiceProvider}
              ownershipVerifiedViaId={ownershipVerifiedViaId}
              ownershipVerificationAlreadyComplete={
                ownershipVerificationAlreadyComplete
              }
              isResumeSignup={isResumeSignup}
              isAdminCreateUser={isAdminCreateUser}
            />
          </Box>
        ))}

      {screen === "security-pin" &&
        ((!isServiceProvider &&
          (requiresSecurityPin(adminChangeCategory ?? category) ||
            isUpgradeCategory ||
            isEnhancedToCompleteProtection)) ||
          (isServiceProvider &&
            requiresSecurityPin(adminChangeCategory ?? category))) && (
          <SecurityPinGeneration
            isAdminCreateUser={isAdminCreateUser || isAdmin}
            titleText={
              isUpgradeCategory || isEnhancedToCompleteProtection
                ? isAdmin || isAdminCreateUser
                  ? "Customer Security PIN"
                  : "Create your Security PIN"
                : from === "add-property"
                  ? "Security PIN"
                  : "User's Security PIN"
            }
            confirmText={
              isUpgradeCategory || isEnhancedToCompleteProtection
                ? isAdmin || isAdminCreateUser
                  ? "Confirm Customer Security PIN"
                  : "Confirm your Security PIN"
                : "Confirm User's Security PIN"
            }
            subTitletext={
              isUpgradeCategory || isEnhancedToCompleteProtection
                ? isAdmin || isAdminCreateUser
                  ? "Complete Protection requires a 5-digit Security PIN for UCC unlock and support verification."
                  : "Complete Protection requires a 5-digit Security PIN you'll use for UCC unlock and when contacting support."
                : "You can change User's security PIN from Users List table anytime you want."
            }
            onCloseBtnFun={handleMonitoringLastStep}
            apiCall={onFinalPIN}
            securityPinResponse={securityPINResponse}
            loader={propertyUsersLoader}
            userEmail={userEmail}
            isTailwindComponent={isTailwindComponent}
            autoAdvanceOnSuccess={isServiceProvider}
          />
        )}
      {screen === "bio-metric" && (
        <Box className="accountBoxWrapper text-center m-auto">
          <Box className="" sx={{ mb: 1 }}>
            <Typography variant="h4" className="card-title text-uppercase">
              Biometric
            </Typography>
          </Box>
          <Typography
            variant="h6"
            className="text-center px-5 caption my-5 mb-lg-4"
          >
            Once the sign-up process is completed successfully, kindly prompt
            the user to add their biometric details.
          </Typography>

          <Button
            className="next_button mt-3"
            type="submit"
            onClick={goToSignatureStep}
          >
            Go to Signature step
          </Button>
        </Box>
      )}
      {screen === "signature" && (
        <Box className="bg-white pb-3 d-flex justify-content-center align-items-center text-center m-auto">
          <SignatureScreen
            isAdminCreateUser={isAdminCreateUser}
            onBtnClick={() => {
              onChangeModalScreen("beneficiaries");
              setIsBeneficiariesSkip(false);
            }}
            HideSkipBtn={() => {}}
            admin_id={admin_id}
            user_id={user_id}
            selectedRowData={selectedRowData}
          />
        </Box>
      )}
      {(screen === "beneficiaries" || screen === "welcome") && (
        <Box
          className={`tailwind_component bg-white py-4 m-auto ${
            screen === "welcome" ? "text-center" : "text-left"
          }`}
        >
          <BeneficiaryForm
            isAdminCreateUser={isAdminCreateUser || from === "add-property"}
            from={from}
            onBtnClick={() => {
              onChangeModalScreen("welcome");
              setIsBeneficiariesSkip(false);
            }}
            admin_id={admin_id}
            user_id={user_id}
            completedProcess={completedProcess}
            skipBenificiary={skipBenificiary}
            isBeneficiariesSkip={isBeneficiariesSkip}
            isResumeSignup={isResumeSignup}
            isTailwindComponent={isTailwindComponent}
            isServiceProvider={isServiceProvider}
            finalScreen={
              category !== "complete_protection"
                ? adminChangeCategory !== "complete_protection"
                  ? true
                  : false
                : false
            }
            category={adminChangeCategory ? adminChangeCategory : category}
            userEmail={userEmail}
            // Welcome email already sent from handleMonitoringLastStep after
            // the PIN; signup allows a single beneficiary.
            welcomeEmailAfterPin={welcomeSentAfterPin}
            maxBeneficiaries={1}
          />
        </Box>
      )}

      {getObjLength(subscribeFreeMonitoring) &&
      !subscribeFreeMonitoring?.success ? (
        <AlertDialog
          // isTailwindComponent={isTailwindComponent}
          type={"Error"}
          openPopup={true}
          onClose={true}
          onCloseFun={closeSubscribeModal}
          mesage={
            subscribeFreeMonitoring?.success
              ? subscribeFreeMonitoring?.message
              : subscribeFreeMonitoring?.data?.message || "Something went wrong"
          }
        />
      ) : null}
      <Loader open={riskManagementLoader && !suppressGlobalLoader} />
      <Loader open={awaitingWelcomeEmail} />
    </Box>
  );
};

export default SecurityInfoAndCardPayment;
